<template>
    <div>
        <div>请稍等……</div>
        <div>请稍等……</div>
        <div>请稍等……</div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    mounted() {
        const isProd = window.location.origin === 'https://gx.feihua100.com';
        const envName = isProd ? '' : 'test_';
        const CDN_URL = 'https://p.gsxcdn.com/';

        const url = `${CDN_URL + envName}${
            window.location.pathname.includes('policychild')
                ? 'child_policy'
                : window.location.pathname.includes('policyprotocol')
                    ? 'policy_protocol'
                    : 'policy'
        }.html?version=${Math.random()}`;
        axios({
            method: 'get',
            url,
        }).then(res => {
            document.write(res);
        });
    }
};


</script>
<style scoped>
iframe {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    border: none;
}
</style>
